import * as React from 'react'
import { ModalWindow } from '$views/components/ModalWindow'
import { Text, Block } from '$views/components'
import { IconWithText } from '$views/components/IconWithText'
import { routeProvider } from '$utils/routeProvider'
import { Fade } from '$views/components/Fade'
import copyIcon from '$icons/copy.svg'
import whatsappIcon from '$icons/whatsapp.svg'
import emailIcon from '$icons/email.svg'
import { tagManager } from '$infrastructure/tagManager/tagManager'

interface Props {
  url: string
  subject?: string
  title: string
  subtitle: string
  onClose: () => void
}

interface NavigatorWithClipboardProps extends Navigator {
  clipboard?: any
}

export const ShareModal: React.SFC<Props> = ({ onClose, title, url, subtitle, subject }) => {
  const [showCopyToClipboard, setShowToClipboard] = React.useState<boolean>(false)

  const onClickEmailShare = () => {
    tagManager.push({ event: 'fam', fam_id: 'ShareEmail' })
    window.location.assign(routeProvider.shareOnEmail(subject, url))
  }

  const onClickWhatsappShare = () => {
    tagManager.push({ event: 'fam', fam_id: 'ShareWhatsApp' })
    window.location.assign(routeProvider.shareOnWhatsapp(url))
  }

  const onClickCopy = () => {
    tagManager.push({ event: 'fam', fam_id: 'ShareLink' })
    setShowToClipboard(true)
    const navigatorWithClipboardProps: NavigatorWithClipboardProps = navigator
    if (navigatorWithClipboardProps.clipboard) {
      navigatorWithClipboardProps.clipboard.writeText(url)
    }
    setTimeout(() => setShowToClipboard(false), 2000)
  }

  return (
    <ModalWindow onClose={onClose}>
      <Text title>{title}</Text>
      <Text marginTop="base">{subtitle}</Text>
      <Block flex marginTop="small">
        <IconWithText
          label="Whatsapp"
          onClick={onClickWhatsappShare}
          iconSrc={whatsappIcon}
          backgroundColor="darkGrey"
          iconColor="white"
        />
        <IconWithText
          label="Email"
          onClick={onClickEmailShare}
          iconSrc={emailIcon}
          backgroundColor="darkGrey"
          iconColor="white"
        />
        <Block>
          <IconWithText
            label="Copiar"
            onClick={onClickCopy}
            iconSrc={copyIcon}
            backgroundColor="darkGrey"
            iconColor="white"
          />
        </Block>
      </Block>
      <Block>
        <Fade showBlock={showCopyToClipboard}>
          <Text color="menu" marginTop="small" weight="medium">
            🎉 Enlace copiado!
          </Text>
        </Fade>
      </Block>
    </ModalWindow>
  )
}



// WEBPACK FOOTER //
// ./src/views/components/ShareModal/ShareModal.tsx